<template>
    <v-dialog v-model="dialog" persistent max-width="900px" v-if="permisos.show">
        <template v-slot:activator="{ on }">
            <v-tooltip top>
                <v-btn
                        flat
                        icon
                        large
                        color="primary"
                        slot="activator"
                        v-on="on"
                >
                    <v-badge class="badge-btn-entregas" color="red darken-3">
                        <template slot="badge" v-if="item.objeto.entregas && item.objeto.entregas.length">
                            <span>{{item.objeto.entregas.length}}</span>
                        </template>
                        <v-icon color="primary">fas fa-people-carry</v-icon>
                    </v-badge>
                </v-btn>
                <span>Entregas</span>
            </v-tooltip>
        </template>
        <v-card>
            <v-toolbar class="elevation-0">
                <v-list two-line>
                    <v-list-tile style="background-color: transparent !important;">
                        <v-list-tile-avatar size="40" color="primary" class="white--text">
                            <v-icon>fas fa-people-carry</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content class="truncate-content">
                            <v-list-tile-title class="title">Entregas de {{item.type}}</v-list-tile-title>
                            <v-list-tile-sub-title class="caption">Prescripción: {{prescripcion.NoPrescripcion}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-tooltip left>
                                <v-btn
                                        slot="activator"
                                        icon
                                        @click="dialog = false"
                                >
                                    <v-icon
                                    >
                                        close
                                    </v-icon>
                                </v-btn>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-divider class="my-0"></v-divider>
            <v-window
                    v-model="window"
                    class="elevation-1"
            >
                <v-window-item>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap border-rad-sm overflow-hidden align-center justify-center fill-height>
                            <v-flex xs12>
                                <card-basica-tecnologia-entrega :key-tecnologia="keyTecnologia" :item="item.objeto" expand></card-basica-tecnologia-entrega>
                            </v-flex>
                            <v-flex xs12>
                                <v-card>
                                    <v-list two-line>
                                        <v-list-tile style="background-color: transparent !important;">
                                            <v-list-tile-content class="truncate-content">
                                                <v-list-tile-title class="body-2">Entregas registradas</v-list-tile-title>
                                                <v-list-tile-sub-title class="caption">Total registrado: {{cantidadEntregada}} de {{item.cantidadFormulada}}</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <template v-if="prescripcion.CodAmbAte === 30 || (prescripcion.CodAmbAte === 22 && !prescripcion.RefAmbAte)">
                                                    <v-tooltip left v-if="cantidadEntregada >= item.cantidadTotal">
                                                        <v-chip slot="activator" label color="success" text-color="white">
                                                            <v-icon left>fas fa-check</v-icon> Cantidad total registrada
                                                        </v-chip>
                                                        <span>Ya está cubierta la cantidad total a registrar</span>
                                                    </v-tooltip>
                                                    <v-chip v-else-if="item.objeto.EstJM === 2" slot="activator" label color="error" text-color="white">
                                                        <v-icon left>fas fa-exclamation-triangle</v-icon> {{item.objeto.estado_junta || item.objeto.EstadoJunta}}
                                                    </v-chip>
                                                    <template v-else>
                                                        <v-tooltip left>
                                                            <v-btn
                                                                    slot="activator"
                                                                    icon
                                                                    flat
                                                                    :color="permisos.add ? 'primary' : 'grey'"
                                                                    @click="permisos.add ? window = 1 : null"
                                                            >
                                                                <v-icon
                                                                >
                                                                    add
                                                                </v-icon>
                                                            </v-btn>
                                                            <span>{{permisos.add ? 'Registrar entrega' : 'Sin permisos para registrar entregas'}}</span>
                                                        </v-tooltip>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <v-tooltip left>
                                                        <v-chip slot="activator" label color="error" text-color="white">
                                                            <v-icon left>fas fa-exclamation-triangle</v-icon> No se pueden realizar entregas
                                                        </v-chip>
                                                        <span>Segun ámbito de entrega, la entidad no puede realizar entregas</span>
                                                    </v-tooltip>
                                                </template>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                    <v-divider class="my-0"></v-divider>
                                    <v-data-table
                                            :items="item.objeto.entregas"
                                            hide-actions
                                            :headers="headers"
                                            no-data-text="No hay entregas registradas"
                                    >
                                        <template v-slot:items="props">
                                            <td class="text-xs-center" style="height: 36px !important;">
                                                <v-tooltip left v-if="(props.index === item.objeto.entregas.length - 1) && props.item.EstEntrega === 1">
                                                    <v-btn
                                                            flat
                                                            icon
                                                            slot="activator"
                                                            :color="permisos.anular ? 'error' : 'grey'"
                                                            @click="permisos.anular ? openDialogCancel(props) : null"
                                                    >
                                                        <v-icon
                                                        >
                                                            ti ti-trash
                                                        </v-icon>
                                                    </v-btn>
                                                    <span>{{permisos.anular ? 'Anular' : 'Sin permisos para anular'}}</span>
                                                </v-tooltip>
                                            </td>
                                            <td style="height: 36px !important;">
                                                {{ props.item.id }}
                                            </td>
                                            <td style="height: 36px !important;">
                                                {{ props.item.FecEntrega }}
                                            </td>
                                            <td class="text-xs-center" style="height: 36px !important;">
                                                {{ props.item.CantTotEntregada }}
                                            </td>
                                            <td class="text-xs-center" style="height: 36px !important;">
                                                <a v-if="item.TipoTec && props.item.CodSerTecEntregado" @click="getDetalleTechnologi(item.TipoTec, props.item.CodSerTecEntregado)">{{item.TipoTec}}{{props.item.CodSerTecEntregado}}</a>
                                                <template v-else>
                                                    <span class="red--text">
                                                        <v-icon>fas fa-exclamation-triangle</v-icon> {{props.item.CausaNoEntrega ? 'No entregado' : ''}}
                                                    </span>
                                                </template>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-window-item>
                <v-window-item>
                    <v-container fluid grid-list-md class="pt-2">
                        <v-layout row wrap border-rad-sm overflow-hidden align-center justify-center fill-height>
                            <v-flex xs12>
                                <card-basica-tecnologia-entrega :key-tecnologia="keyTecnologia" :item="item.objeto" expand></card-basica-tecnologia-entrega>
                            </v-flex>
                            <v-flex xs12>
                                <registro-entrega :window="window" :prescripcion="prescripcion" :item="item" @cancel="window = 0"></registro-entrega>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-window-item>
            </v-window>
            <app-section-loader :status="processingSection"></app-section-loader>
        </v-card>
        <detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="processingSection = false"></detail-technologi-dialog>
        <confirmation-dialog
                ref="dialogCancel"
                color="error"
                heading="¿Anulación de entrega?"
                :message="`¿Está seguro de anular la entrega No. <strong>${selectedEntrega ? selectedEntrega.item.id : ''}</strong>?`"
                @onConfirm="cancelEntrega"
                @onCancel="selectedEntrega = null"
        >
        </confirmation-dialog>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            prescripcion: {
                type: Object,
                default: null
            },
            item: {
                type: Object,
                default: null
            },
            keyTecnologia: {
                type: String,
                default: 'medicamentos'
            }
        },
        components: {
            RegistroEntrega: () => import('@/components/Prescripciones/ServiciosTecnologias/RegistroEntrega'),
            CardBasicaTecnologiaEntrega: () => import('@/components/Prescripciones/ServiciosTecnologias/CardBasicaTecnologiaEntrega')
        },
        computed: {
            cantidadEntregada () {
                return this.item.objeto.entregas && this.item.objeto.entregas.length ? window.lodash.sum(this.item.objeto.entregas.map(x => Number(x.CantTotEntregada))) : 0
            },
            permisos () {
                return this.$store.getters.getPermissionModule('entregas')
            }
        },
        watch: {
          'dialog' (val) {
              if (val === false) this.window = 0
          }
        },
        data: () => ({
            selectedEntrega: null,
            processingSection: false,
            dialog: false,
            window: 0,
            headers: [
                {
                    text: '',
                    sortable: false
                },
                {
                    text: 'Código',
                    sortable: false
                },
                {
                    text: 'Fecha Entrega',
                    sortable: false
                },
                {
                    text: 'Cantidad',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Servicio/Tecnología',
                    align: 'center',
                    sortable: false
                }
            ]
        }),
        methods: {
            getDetalleTechnologi (type, code) {
                this.processingSection = true
                this.$refs.dialogInfoTechnologi.getDetail(type, code)
            },
            openDialogCancel (item) {
                this.selectedEntrega = item
                this.$refs.dialogCancel.open()
            },
            cancelEntrega () {
                this.$refs.dialogCancel.loading()
                this.axios.delete(`entregas/${this.selectedEntrega.item.id}`)
                    .then(response => {
                        console.log('okkk', response)
                        this.item.objeto.entregas.splice(this.selectedEntrega.index, 1)
                        this.$store.commit('snackbar', {color: 'success', message: `Se anuló la entrega No. ${this.selectedEntrega.item.id} de forma correcta`})
                        this.$refs.dialogCancel.close()
                    }).catch(e => {
                    this.$refs.dialogCancel.loading(false)
                    this.$store.commit('snackbar', {color: 'error', message: `al tratar de anular la entrega No. ${this.selectedEntrega.item.id}`, error: e})
                })
            }
        }
    }
</script>

<style>
    .badge-btn-entregas>span.v-badge__badge {
        height: 15px !important;
        width: 15px !important;
        font-size: 10px !important;
        right: -4px !important;
    }
</style>